<script setup>
import { computed, defineProps } from 'vue';
import './SubscriptionBar.scss'; // Import the styles for the component
// Props
const props = defineProps({
  remainingSubscriptions: {
    type: Number,
    required: true,
  },
  totalSubscriptions: {
    type: Number,
    required: true,
  },
  text: {
    type: String,
    required: true,
  },
});

// Computed property to calculate the progress bar width
const progressBarWidth = computed(() => {
  if (props.totalSubscriptions === 0) return '0%';
  return `${(props.remainingSubscriptions / props.totalSubscriptions) * 100}%`;
});
</script>

<template>
  <div class="subscription-info subscription-bar">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 22H7C6.59 22 6.25 21.66 6.25 21.25C6.25 20.84 6.59 20.5 7 20.5H17C17.41 20.5 17.75 20.84 17.75 21.25C17.75 21.66 17.41 22 17 22Z"
        fill="#FFB800"
      />
      <path
        d="M20.35 5.52004L16.35 8.38004C15.82 8.76004 15.06 8.53004 14.83 7.92004L12.94 2.88004C12.62 2.01004 11.39 2.01004 11.07 2.88004L9.16998 7.91004C8.93998 8.53004 8.18997 8.76004 7.65998 8.37004L3.65998 5.51004C2.85998 4.95004 1.79998 5.74004 2.12998 6.67004L6.28998 18.32C6.42998 18.72 6.80998 18.98 7.22998 18.98H16.76C17.18 18.98 17.56 18.71 17.7 18.32L21.86 6.67004C22.2 5.74004 21.14 4.95004 20.35 5.52004ZM14.5 14.75H9.49998C9.08998 14.75 8.74998 14.41 8.74998 14C8.74998 13.59 9.08998 13.25 9.49998 13.25H14.5C14.91 13.25 15.25 13.59 15.25 14C15.25 14.41 14.91 14.75 14.5 14.75Z"
        fill="#FFB800"
      />
    </svg>

    <div class="text">
      <div class="text-block">
        {{ text }}
        <span> {{ remainingSubscriptions }} out of {{ totalSubscriptions }}</span>
      </div>
      <div class="progress">
        <div class="bar" :style="{ width: progressBarWidth }"></div>
      </div>
    </div>
  </div>
</template>